
import { UserProfile } from "@/types/profile";
import { UseFormRegister } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface SecuritySettingsFormProps {
  register: UseFormRegister<UserProfile>;
  profile: UserProfile;
}

export const SecuritySettingsForm = ({ register, profile }: SecuritySettingsFormProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Security & Privacy</CardTitle>
        <CardDescription>
          Manage your account security and privacy settings
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Public Profile</Label>
            <p className="text-sm text-muted-foreground">
              Allow others to view your profile
            </p>
          </div>
          <Switch 
            checked={profile.privacy_settings?.public_profile}
            {...register("privacy_settings.public_profile")}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Show Contact Info</Label>
            <p className="text-sm text-muted-foreground">
              Display your contact information to others
            </p>
          </div>
          <Switch 
            checked={profile.privacy_settings?.show_contact}
            {...register("privacy_settings.show_contact")}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Show Rates</Label>
            <p className="text-sm text-muted-foreground">
              Display your rates to potential clients
            </p>
          </div>
          <Switch 
            checked={profile.privacy_settings?.show_rates}
            {...register("privacy_settings.show_rates")}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Enable Booking</Label>
            <p className="text-sm text-muted-foreground">
              Allow others to book you through the platform
            </p>
          </div>
          <Switch 
            checked={profile.privacy_settings?.enable_booking}
            {...register("privacy_settings.enable_booking")}
          />
        </div>
      </CardContent>
    </Card>
  );
};
